import { KeyOutlined, LockOutlined } from "@ant-design/icons"
import { Collapse, Flex, Form, Input, Space } from "antd"
import React from "react"

import FormPasswordStrengthIndicator from "../../../../../components/FormPasswordStrengthIndicator"

export function PasswordSecurityPasswords() {
  return (
    <Form.Item label={"Password Management"}>
      <Collapse className={"bg-transparent"} expandIconPosition={"end"}>
        <Collapse.Panel
          header={
            <Space>
              <KeyOutlined />
              Change Password
            </Space>
          }
          key="1"
        >
          <Form.Item
            name="current_password"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const newPassword = getFieldValue("new_password")

                  if (newPassword && !value) {
                    return Promise.reject(
                      new Error("Please enter your current password")
                    )
                  }

                  return Promise.resolve()
                }
              })
            ]}
          >
            <Input.Password
              autoComplete="new-password"
              prefix={<LockOutlined />}
              placeholder={"Current Password"}
            />
          </Form.Item>
          <Form.Item
            name="new_password"
            validateTrigger={["onChange"]}
            rules={[
              { min: 8, message: "Password must be at least 8 characters" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const currentPassword = getFieldValue("current_password")

                  if (currentPassword || value) {
                    if (!value) {
                      return Promise.reject(
                        new Error("Password cannot be empty")
                      )
                    }

                    if (currentPassword === value) {
                      return Promise.reject(
                        new Error("Password cannot be the same")
                      )
                    }
                  }

                  return Promise.resolve()
                }
              })
            ]}
          >
            <Flex vertical>
              <Input.Password
                name={"new_password"}
                prefix={<LockOutlined />}
                placeholder={"New Password"}
              />
              {/*<FormPasswordStrengthIndicator name={"newPassword"} />*/}
            </Flex>
          </Form.Item>

          <Form.Item
            name="confirm_new_password"
            validateTrigger={["onChange"]}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const newPassword = getFieldValue("new_password")

                  if (newPassword && !value) {
                    return Promise.reject(
                      new Error("Please confirm your new password")
                    )
                  }

                  if ((newPassword || value) && newPassword !== value) {
                    return Promise.reject(new Error("Passwords do not match"))
                  }

                  return Promise.resolve()
                }
              })
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder={"Confirm Password"}
            />
          </Form.Item>

          <FormPasswordStrengthIndicator name={"new_password"} />
        </Collapse.Panel>
      </Collapse>
    </Form.Item>
  )
}
